import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
export const BACKEND_ORIGIN = BACKEND_URL;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = config.__guestToken || localStorage.getItem("hp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
